import ko from "knockout";
// expose KO globally so dynamic dev UI can re-bind
window.ko = ko;
import $ from "jquery";
import { setupDataDogLogging } from "./components/SharedLogging.js";
import { SessionViewModel } from "./viewModels/SessionViewModel.js";
import { LogViewModel } from "./viewModels/LogViewModel.js";
import { LoginViewModel } from "./viewModels/LoginViewModel.js";
import { AppViewModel } from "./viewModels/AppViewModel.js";
import { AlertViewModel } from "./viewModels/AlertViewModel.js";
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap JS bundle (includes Popper for tooltips, popovers, dropdowns, etc.)
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// Popover is available as a module
import Popover from "bootstrap/js/dist/popover";
// Knockout binding for Bootstrap popovers
ko.bindingHandlers.popover = {
  init(element, valueAccessor, allBindings) {
    const content = ko.unwrap(valueAccessor());
    if (content && Popover) {
      const options = {
        trigger: "hover focus",
        placement: allBindings.get ? allBindings.get("popoverPlacement") || "top" : "top",
        content,
      };
      const popInstance = new Popover(element, options);
      ko.utils.domNodeDisposal.addDisposeCallback(element, () => popInstance.dispose());
    }
  },
  update(element, valueAccessor, allBindings) {
    const content = ko.unwrap(valueAccessor());
    const popInstance = Popover && Popover.getInstance ? Popover.getInstance(element) : null;
    if (content) {
      if (popInstance) {
        popInstance.setContent({ ".popover-body": content });
      } else if (Popover) {
        const options = {
          trigger: "hover focus",
          placement: allBindings.get ? allBindings.get("popoverPlacement") || "top" : "top",
          content,
        };
        new Popover(element, options);
      }
    } else if (popInstance) {
      popInstance.dispose();
    }
  },
};
// Import custom styles (moved from public/css) for HMR support
import "./styles.css";
import "detectrtc/DetectRTC.js";
import config from "./config.js";

// Initialize logging
setupDataDogLogging(config.dataDog);

$(document).ready(() => {
  window.logViewModel = new LogViewModel(this, config);
  window.loginViewModel = new LoginViewModel(this, config);
  window.appViewModel = new AppViewModel(config);
  window.alertViewModel = new AlertViewModel(config);
  window.sessionViewModel = new SessionViewModel(this, config);

  ko.applyBindings(window.sessionViewModel);
  // Prevent multiple monitor tabs: broadcast channel guard
  try {
    const bc = new BroadcastChannel("audio-monitor");
    // If another tab is already monitoring, alert and stop UI
    bc.onmessage = (ev) => {
      if (ev.data === "monitor-started") {
        alert("Audio monitoring is already active in another tab.");
        throw new Error("Duplicate audio monitor tab");
      }
    };
    // Announce start of monitoring session
    bc.postMessage("monitor-started");
  } catch (e) {
    console.warn("BroadcastChannel not available or duplicate tab detected", e);
  }
  window.sessionViewModel.start().catch((error) => {
    console.error("Error during starting:", error);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Hide the loading screen after the page is fully loaded
  const loadingScreen = document.getElementById("loadingScreen");
  loadingScreen.style.display = "none";
});
